let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("757CW")).then(() => parcelRequire('9J7a9'));